import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '../pages/HomePage.vue';
import MedialPage from '../pages/MedialPage.vue';
import LoginPage from '../pages/LoginPage.vue';
import RegisterPage from '../pages/RegisterPage.vue';
import VerifyCode from '../pages/VerifyCode.vue';
import SIPCredentialsPage from '../pages/SIPCredentialsPage.vue';
import PasswordPage from '../pages/PasswordPage.vue';
import EditPage from '../pages/EditPage.vue';
import Account from '../pages/Account.vue';
import EditSipInfoPage from '../pages/EditSipInfoPage.vue';
import EditSipPage from '../pages/EditSipPage.vue';
import ForgotPasswordPage from '../pages/ForgotPasswordPage.vue';
import CreateNewPasswordPage from '../pages/CreateNewPasswordPage.vue';
import EditProfile from '../pages/EditProfile.vue';
import PolicyPage from '../pages/PolicyPage.vue';

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
    }, {
      path: '/medial',
      name: 'MedialPage',
      component: MedialPage,
    }, {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
    }, {
      path: '/register/:token?',
      name: 'RegisterPage',
      component: RegisterPage,
      props: true,
    }, {
      path: '/verify/:phone/:token',
      name: 'VerifyPage',
      component: VerifyCode,
      props: true,
    }, {
      path: '/SIPInfo/:phone/:token',
      name: 'SIPCredentialsPage',
      component: SIPCredentialsPage,
      props: true,
    }, {
      path: '/password/:phone/:token',
      name: 'PasswordPage',
      component: PasswordPage,
      props: true,
    }, {
      path: '/edit',
      name: 'EditPage',
      component: EditPage,
      props: true,
    }, {
      path: '/account',
      name: 'Account',
      component: Account,
      props: true,
    }, {
      path: '/editSipInfo/:id',
      name: 'EditSipInfoPage',
      component: EditSipInfoPage,
      props: true,
    }, {
      path: '/editSip/:id?',
      name: 'EditSipPage',
      component: EditSipPage,
      props: true,
    }, {
      path: '/forgot-password',
      name: 'ForgotPasswordPage',
      component: ForgotPasswordPage,
      props: true,
    }, {
      path: '/createNewPassword/:phone/:token',
      name: 'CreateNewPasswordPage',
      component: CreateNewPasswordPage,
      props: true,
    }, {
      path: '/editProfile',
      name: 'EditProfile',
      component: EditProfile,
      props: true,
    }, {
      path: '/policy',
      name: 'PolicyPage',
      component: PolicyPage,
      props: true,
    }, {
      path: '*',
      redirect: '/',
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js